if (!customElements.get('kiukiang-experts')) {
  customElements.define('kiukiang-experts', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.slides = [...this.querySelectorAll('[data-expert-slide]')];
      this.dots = [...this.querySelectorAll('[data-expert-dot]')];
      this.dots.forEach((dot, index) => dot.addEventListener('click', () => this.show(index)));
      this.addEventListener('keydown', (event) => {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        let next = this.current + (event.key === 'ArrowLeft' ? -1 : 1);
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = this.slides.length - 1;
        this.show(next);
        this.dots[this.current]?.focus();
      });
      this.show(Math.min(1, this.slides.length - 1));
    }
    show(index) {
      if (!this.slides.length) return;
      this.current = (index + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, i) => {
        const relative = (i - this.current + this.slides.length) % this.slides.length;
        slide.dataset.position = relative === 0 ? 'center' : relative === 1 ? 'right' : 'left';
        this.dots[i]?.setAttribute('aria-pressed', String(i === this.current));
      });
    }
  });
}
